import { CoreUser, CoreUserOrganization } from '@densityco/lib-api-types';

export type ImpersonateData =
  | { enabled: false }
  | {
      enabled: true;
      id: CoreUser['id'];
      email: CoreUser['email'];
      name: CoreUser['full_name'];
      role: CoreUser['role'];
      organizationId: CoreUserOrganization['id'];
      organizationName: CoreUserOrganization['name'];
    };
export const DEFAULT_IMPERSONATE: ImpersonateData = {
  enabled: false,
};

export enum Environment {
  PRODUCTION = 'PRODUCTION',
  STAGING = 'STAGING',
  LOCAL = 'LOCAL',
  KANDOR = 'KANDOR',
  CUSTOM = 'CUSTOM',
}
export type EnvironmentFlags = {
  useAuth0: boolean;
  showButton: boolean;
  slowMode: boolean;
  legacyAPI: boolean;
};
export type EnvironmentData = (
  | {
      type: Environment.PRODUCTION;
      coreHost: 'https://api.density.io';
    }
  | {
      type: Environment.STAGING;
      coreHost: 'https://core-staging.density.io';
    }
  | {
      type: Environment.LOCAL;
      coreHost: 'http://localhost:8000';
    }
  | {
      type: Environment.KANDOR;
      coreHost: 'http://localhost:8081';
    }
  | {
      type: Environment.CUSTOM;
      coreHost: string;
    }
) &
  EnvironmentFlags;

export const DEFAULT_ENVIRONMENT: EnvironmentData = {
  type: Environment.PRODUCTION,
  coreHost: 'https://api.density.io',
  useAuth0: true,
  showButton: false,
  slowMode: false,
  legacyAPI: false,
};

export type HistoricalQueryData = {
  timeFilter: string | null;
  startDate: string | null;
  endDate: string | null;
  queryDate: string | null;
};
export const DEFAULT_HISTORICAL_QUERY: HistoricalQueryData = {
  timeFilter: null,
  startDate: null,
  endDate: null,
  queryDate: null,
};
